import { useParams } from "@solidjs/router";
import { GovernWorkspace } from "./GovernWorkspace";

export function GovernRoute() {
  const params = useParams();
  return <GovernWorkspace websiteId={params.id ?? ""} />;
}
